// game/map.js
import { GS, WIDTH, HEIGHT, div } from './utility.js';

export class Map {
    constructor(name) {
        this.name = name;
        this.row = -1;
        this.col = -1;
        this.defaultTile = 0;
        this.data = null;
        this.charas = [];

        // Inicializar imágenes
        Map.images = Map.images || new Array(256);
        for (let i = 0; i < 5; i++) {
            Map.images[i] = new Image();
        }
        Map.images[0].src = "/images/grass.png";
        Map.images[1].src = "/images/water.png";
        Map.images[2].src = "/images/forest.png";
        Map.images[3].src = "/images/hill.png";
        Map.images[4].src = "/images/mountain.png";

        // Cargar el mapa 
        this.loadDemoMap();
    }

    // Para Vite, creamos un mapa demo en lugar de cargar un archivo
    loadDemoMap() {
        // Mapa demo de 30x30
        this.row = 30;
        this.col = 30;
        this.defaultTile = 1;
        
        // Inicializar datos
        this.data = new Array(this.row);
        for (let i = 0; i < this.row; i++) {
            this.data[i] = new Array(this.col);
            for (let j = 0; j < this.col; j++) {
                // Borde del mapa
                if (i === 0 || i === this.row - 1 || j === 0 || j === this.col - 1) {
                    this.data[i][j] = 1; // Agua
                } else {
                    this.data[i][j] = 0; // Hierba
                }
            }
        }

        // Añadir algunos elementos al mapa
        // Árboles
        for (let i = 2; i < 7; i++) {
            for (let j = 3; j < 8; j++) {
                if (Math.random() > 0.5) {
                    this.data[i][j] = 2;
                }
            }
        }

        // Colinas
        for (let i = 3; i < 7; i++) {
            for (let j = 8; j < 13; j++) {
                if (Math.random() > 0.5) {
                    this.data[i][j] = 3;
                }
            }
        }

        // Montañas
        for (let i = 8; i < 11; i++) {
            for (let j = 4; j < 8; j++) {
                if (Math.random() > 0.5) {
                    this.data[i][j] = 4;
                }
            }
        }
    }

    // Versión alternativa que carga desde un archivo - Usar si prefieres cargar archivo
    async load(filename) {
        try {
            const response = await fetch(filename);
            const text = await response.text();
            const lines = text.split("\n");
            
            const temp = lines[0].split(" ");
            this.row = parseInt(temp[0]);
            this.col = parseInt(temp[1]);
            this.defaultTile = parseInt(lines[1]);
            
            this.data = new Array(this.row);
            for (let i = 0; i < this.row; i++) {
                this.data[i] = new Array(this.col);
                for (let j = 0; j < this.col; j++) {
                    this.data[i][j] = parseInt(lines[i+2][j]);
                }
            }
        } catch (error) {
            console.error("Error loading map:", error);
            // Fallback a mapa demo si falla la carga
            this.loadDemoMap();
        }
    }

    update() {
        for (let i = 0; i < this.charas.length; i++) {
            this.charas[i].update(this);
        }
    }

    draw(ctx, offset) {
        let startx = div(offset[0], GS);
        let endx = startx + div(WIDTH, GS) + 1;
        let starty = div(offset[1], GS);
        let endy = starty + div(HEIGHT, GS) + 1;

        for (let y = starty; y < endy; y++) {
            for (let x = startx; x < endx; x++) {
                let img = Map.images[this.defaultTile];
                if (x >= 0 && x < this.col && y >= 0 && y < this.row) {
                    img = Map.images[this.data[y][x]];
                }
                ctx.drawImage(img, x * GS - offset[0], y * GS - offset[1]);
            }
        }

        for (let i = 0; i < this.charas.length; i++) {
            this.charas[i].draw(ctx, offset);
        }
    }

    isMovable(x, y) {
        if (x < 0 || x >= this.col || y < 0 || y >= this.row) return false;
        if (this.data[y][x] === 1 || this.data[y][x] === 4) return false;
        
        for (let i = 0; i < this.charas.length; i++) {
            if (this.charas[i].x === x && this.charas[i].y === y) return false;
        }
        
        return true;
    }

    addChara(chara) {
        this.charas.push(chara);
    }
}